// tslint:disable:max-line-length
import * as TypeStyle from 'typestyle';
import { MenuItemCheckIcon } from '../../icons/Icons';
import { AlignItemsCenter, DisplayFlex, FlexDirectionColumn, FlexDirectionColumnReverse, FlexGrow1 } from '../../styles/Flexbox';
import { PreventUserSelect } from '../../styles/PreventUserSelect';
import { TabStyles } from '../../styles/TabStyles';
import { TextEllipsis } from '../../styles/TextEllipsis';

const { Colors, Opacity, Sizing, Spacing, Typography } = TabStyles;

export function MenuItemCheckStyles(flags: { active?: boolean, disabled?: boolean } = {}): React.CSSProperties {
  const checkIcon = MenuItemCheckIcon.icon(flags);
  return {
    backgroundImage: `url('${checkIcon}')`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: `${Spacing.DefaultSpace}px center`
  };
}

export const ListIsActiveClass = 'listIsActive';
export const ListStyleName = TypeStyle.style(
  PreventUserSelect,
  {
    boxSizing: 'border-box',
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    lineHeight: 'normal',
    overflowY: 'auto',
    padding: Spacing.DefaultSpace,
    '-webkit-overflow-scrolling': 'touch',
    $nest: {
      '&:focus, & :focus': { outline: 'none' },
      '&::-moz-focus-inner, & ::-moz-focus-inner': { $unique: true, border: 'none' },

      '& [role="separator"]': {
        background: Colors.F3,
        height: 1,
        margin: '9.5px 0',
      },
      '& [role="group"] > :first-child': {
        ...AlignItemsCenter,
        ...DisplayFlex,
        fontWeight: 'bold',
        minHeight: Sizing.ListRowHeight,
      },
      [`&:focus [role="option"][aria-selected="true"], &.${ListIsActiveClass} [role="option"][aria-selected="true"]`]: {
        backgroundColor: Colors.F3, // (ab)use aria-selected as "focus"
      },
      [`&:focus [role="option"][aria-selected="true"][aria-disabled="true"], &.${ListIsActiveClass} [role="option"][aria-selected="true"][aria-disabled="true"]`]: {
        backgroundColor: '#b7b7b7', // hack to show as F3 when Opacity.Disabled
      },
      '& [role="option"]': {
        ...AlignItemsCenter,
        ...DisplayFlex,
        minHeight: Sizing.ListRowHeight,
        paddingLeft: Spacing.DefaultSpace * 2 + MenuItemCheckIcon.width,
        paddingRight: Spacing.DefaultSpace,
        $nest: {
          '&[aria-checked="true"]': MenuItemCheckStyles(),
          '&:hover': {
            backgroundColor: Colors.F2,
          },
          '&:active': {
            backgroundColor: Colors.F3,
          },
          '&[aria-disabled="true"]': {
            backgroundColor: 'transparent',
            opacity: Opacity.Disabled,
          },
        }
      }
    }
  },
);

export const EllipsedStyleName = TypeStyle.style(FlexGrow1, TextEllipsis);

export const FilteringListStyleName = TypeStyle.style(
  {
    ...DisplayFlex,
    ...FlexDirectionColumn,
    boxSizing: 'border-box',
    lineHeight: 'normal',
    $nest: {
      '&.reverse': {
        ...FlexDirectionColumnReverse,
      },
    },
  },
);
